export default "__VITE_ASSET__21ae72b5__"